
import { defineComponent } from 'vue';
import ReportOptionComponent from "@/components/reportsComponents/ReportOption.vue";
import SystemLogsList from './SystemLogsList.vue';
import CommissionsList from './CommissionsList.vue';
import DepositTransferHistory from './DepositTransferHistory.vue';

export default defineComponent({
    name: "ReportsPage",

    components: { ReportOptionComponent, SystemLogsList, CommissionsList, DepositTransferHistory },

    data() {
        return {
            statusComponent: "Menu",
            options: [
                {
                    title: "فعالیت سیستم",
                    path: "logs",
                    icon: 'mdi-file-document-outline'
                },
                {
                    title: "کارمزد های سیستم",
                    path: "commissions",
                    icon: 'mdi-currency-usd'
                },
                {
                    title: "گردش حساب سپرده",
                    path: "depositTransferHistory",
                    icon: 'mdi-file-document-outline'
                },
            ]
        }
    },

    methods: {
        changeStatusComponent(status: string): void {
            this.$router.push({
                query: { ...this.$route.query, path: status },
            });

            switch (status) {
                case "logs":
                    this.statusComponent = "logs";
                    break;
                case "commissions":
                    this.statusComponent = "commissions";
                    break;
                case "depositTransferHistory":
                    this.statusComponent = "depositTransferHistory";
                    break;

                default:
                    this.statusComponent = "Menu";
                    // Optionally clear the query parameter or set to default
                    this.$router.push({
                        query: { ...this.$route.query, path: undefined },
                    });
                    break;
            }
        },

        resetStatusComponent(): void {
            this.statusComponent = "Menu";
        },

        selectedOption(option: { title: string, path: string, icon: string }): void {
            this.changeStatusComponent(option.path)
        }
    },

    // Watch for route changes to update statusComponent
    watch: {
        "$route.query.path"(newPath: string) {
            if (newPath && newPath !== this.statusComponent) {
                this.changeStatusComponent(newPath);
            }

            if(!newPath) {
                this.resetStatusComponent();
            }
        },
    },
})
